/**
 * Orbit data predicts a satellite's position for about two weeks either side of its epoch (when it was
 * measured). Beyond that no position is given at all: live, for tracks, for passes or for alerts. Kept apart
 * from the orbit maths so the page can check it without loading that.
 */
export const MAX_EPOCH_AGE = 14 * 86400e3;
export const epochOk = (s: { epoch: number }, t: number) => Math.abs(t - s.epoch) < MAX_EPOCH_AGE;

/**
 * Orbits measured more than this (3 days) from the moment in question can put a pass a few minutes out: no "visible now"
 * banner and no ISS alert comes from them, and Tonight says so under its passes. Drawing satellites on the sky keeps the
 * two-week limit.
 */
export const FRESH_ORBIT_AGE = 3 * 86400e3;
